export default __webpack_public_path__ + "static/media/sidebar-1.9b39fe62.svg";